var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m_t30"},[_c('div',{staticClass:"app-content main-width"},[_c('div',{staticClass:"policy"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }